import {HarcTuru} from "@/enum/HarcTuru";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";

/**
 * Tahsil harcının aşamaya/orana göre dokuz türü (API: TaksitHesaplayici::TAHSIL_HARCI_TURLERI).
 * Sistemin ürettiği kalem `tahsil_harci` (1) türündedir; aktarımla ya da elle girişle diğerleri
 * de gelebilir. İcraya başvurma, vekalet suret, peşin, cezaevi … harçları tahsil harcı DEĞİLDİR.
 */
export const TAHSIL_HARCI_TURLERI: number[] = [
    HarcTuru.tahsil_harci,
    HarcTuru.hacizden_sonra,
    HarcTuru.hacizden_rehinli,
    HarcTuru.resmi_ozel,
    HarcTuru.takip_talebi_bulunmayan,
    HarcTuru.gayrimenkul_ve_gemilerin_icrasi,
    HarcTuru.gayrimenkul_ve_gemilerin_tahliyesi,
    HarcTuru.menkul_teslimi_icra,
    HarcTuru.menkul_teslimi_tahliye,
];

/** Oran hiçbir kaynaktan çözülemezse gösterilen yasal taban oran (eski sabit gösterim). */
export const VARSAYILAN_TAHSIL_HARCI_ORANI = 4.55;

function sayi(deger: any): number {
    if (deger === null || deger === undefined || deger === "") return 0;
    const n = Number(deger);
    return Number.isFinite(n) ? n : 0;
}

export function tahsilHarciTuruMu(harcTuruId: any): boolean {
    return TAHSIL_HARCI_TURLERI.includes(Number(harcTuruId));
}

/** Takibin tüm talep/alacaklarındaki harç kalemlerinden tahsil harcı türünde olanlar. */
function tahsilHarciKalemleri(takip: any): any[] {
    const kalemler: any[] = [];
    (takip?.talepler || []).forEach((talep: any) => {
        (talep?.alacaklar || []).forEach((alacak: any) => {
            (alacak?.alacak_kalemleri || []).forEach((kalem: any) => {
                const alanId = kalem?.alacak_kalemi_alani?.id ?? kalem?.alacak_kalemi_alani_id;
                if (Number(alanId) === AlacakKalemiAlani.harc && tahsilHarciTuruMu(kalem?.harc_turu_id)) {
                    kalemler.push(kalem);
                }
            });
        });
    });
    return kalemler;
}

/** Henüz tahsil edilmemiş tahsil harcı toplamı (yalnız tahsil türleri). */
export function tahsilHarciToplami(takip: any): number {
    const toplam = tahsilHarciKalemleri(takip)
        .reduce((t: number, k: any) => t + sayi(k.tahsil_edilmeyen_tutar), 0);
    return Math.round((toplam + Number.EPSILON) * 100) / 100;
}

/**
 * Takibin tahsil harcı oranı (%). Öncelik API ile aynı (TaksitHesaplayici::tahsilHarciOraniGetir):
 * takibe özel oran, yoksa tahsil harcı kaleminde donmuş oran (önce `tahsil_harci` türü),
 * ikisi de yoksa yasal taban oran.
 */
export function tahsilHarciOrani(takip: any): number {
    const takipOrani = sayi(takip?.tahsil_harci_orani);
    if (takipOrani > 0) return takipOrani;

    const kalemler = tahsilHarciKalemleri(takip)
        .slice()
        .sort((a: any, b: any) => Number(a.harc_turu_id) - Number(b.harc_turu_id));
    for (const kalem of kalemler) {
        const oran = sayi(kalem.harc_orani);
        if (oran > 0) return oran;
    }
    return VARSAYILAN_TAHSIL_HARCI_ORANI;
}
